var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.783 13.789c.016-.199.027-.394.027-.583 0-4.49-3.653-8.143-8.143-8.143s-8.144 3.653-8.144 8.143c0 .189.011.383.028.583a2.71 2.71 0 0 0-1.536 2.434 2.718 2.718 0 0 0 2.715 2.714h13.874a2.718 2.718 0 0 0 2.714-2.715 2.71 2.71 0 0 0-1.535-2.434zM8.143 8.782v.805a.905.905 0 1 0 1.81 0V7.492a6.28 6.28 0 0 1 1.809-.548v3.246a.905.905 0 1 0 1.81 0V6.945c.639.092 1.246.279 1.81.548v2.094a.905.905 0 1 0 1.809 0v-.805A6.31 6.31 0 0 1 19 13.207c0 .096-.01.2-.015.302H6.347c-.005-.102-.014-.207-.014-.303a6.31 6.31 0 0 1 1.81-4.424zm11.46 8.345H5.73a.906.906 0 0 1 0-1.81h13.874a.906.906 0 0 1 0 1.81z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsProvider);
export default __webpack_public_path__ + "static/media/cons-provider.b3a50893c64a4c41a840308a933c21ed.svg";
export { ForwardRef as ReactComponent };